import { render, staticRenderFns } from "./posPicker.vue?vue&type=template&id=44abafb4&scoped=true&"
import script from "./posPicker.vue?vue&type=script&lang=js&"
export * from "./posPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44abafb4",
  null
  
)

export default component.exports